import React from "react";
import "./styles/Character.css";

function Character() {
    return (
        <div className="Character">
            <h1>Character Customization Coming Soon!</h1>
            <h3>Choose your avatar</h3>
            <img src="/cats.png" alt="" width="50vw"/>
            <h3>Complete missions and quests to earn cosmetic items for your character.</h3>
            <img src="/cat_costumes.png" alt="" width="50vw"/>

        </div>
    );
};

export default Character;